/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarrierDeliveryNotesInPool } from '../../models/carrier-delivery-notes-in-pool';
import { KeyType } from '../../models/key-type';

export interface GetCarrierDeliveryNotesMetadataInPool$Params {
  organizationSiteKey: KeyType;
}

export function getCarrierDeliveryNotesMetadataInPool(http: HttpClient, rootUrl: string, params: GetCarrierDeliveryNotesMetadataInPool$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierDeliveryNotesInPool>> {
  const rb = new RequestBuilder(rootUrl, getCarrierDeliveryNotesMetadataInPool.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CarrierDeliveryNotesInPool>;
    })
  );
}

getCarrierDeliveryNotesMetadataInPool.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes';
